import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { valueStack, valuePriced, valueTotals, offers, media } from '../data/product';
import { CtaButton } from './CtaButton';
import { requestOffer } from '../utils/offerBus';
import { GuaranteeBadge, ShopHotspot } from './BannerOverlays';
export function ValueStackSection() {
  return <section aria-labelledby="value-heading" className="border-b border-white/10 bg-ink-950" data-id="element-1401" data-mp="1he09l125i4pq">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-1402" data-mp="tnw8p1gckj2f">
        <h2 id="value-heading" className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-1403" data-mp="opunoazd29ob">
          The complete
          <br data-id="element-1404" data-mp="ylo25zwn4d8q" />
          <span className="text-grit-500" data-id="element-1405" data-mp="yl5vsag9kin3">GritVue X1 system.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-1406" data-mp="2e2g3188dsy84">
          Built for real work. The GritVue X1™ combines hands-free illumination, interchangeable lenses and a
          complete care system in one premium, work-ready package.
        </p>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start" data-id="element-1407" data-mp="1nfbci45kpqwt">
          <div className="border border-white/12 bg-ink-900" data-id="element-1408" data-mp="1se5z7h6nvzm7">
            <p className="border-b border-white/10 px-5 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400 sm:px-6" data-id="element-1409" data-mp="1weyd4nqhasot">
              Everything included
            </p>
            <ul data-id="element-1410" data-mp="14na5geinaucb">
              {valuePriced.map(row => <li key={row.item} className="flex items-start justify-between gap-5 border-b border-white/5 px-5 py-4 sm:px-6" data-id="element-1411" data-mp="18o2bz004ul4w">
                  <span className="min-w-0" data-id="element-1412" data-mp="1dl2krioda1zp">
                    <span className="block text-base font-semibold text-offwhite sm:text-lg" data-id="element-1413" data-mp="1ie5ebqt59bfw">{row.item}</span>
                    <span className="mt-0.5 block text-[13px] text-steel-500" data-id="element-1414" data-mp="kxghkbj1wzdd">{row.note}</span>
                  </span>
                  <span className="shrink-0 text-right" data-id="element-1415" data-mp="pw02q9ptm74o">
                    <span className="block font-display text-2xl font-bold leading-none text-steel-300" data-id="element-1416" data-mp="1t7yrek04h7lb">
                      {row.price}
                    </span>
                    {row.price.startsWith('$') && <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-steel-500" data-id="element-1417" data-mp="21zqx6he7bsjk">
                        Value
                      </span>}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-1418" data-mp="15b2ucsb24buq">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1419" data-mp="1jakn1irh499d">
                Total separate value
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-offwhite" data-id="element-1420" data-mp="1edkgz7umj6i9">
                {valueTotals.total}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-1421" data-mp="2ppv4ozuigcfu">
              <span className="min-w-0" data-id="element-1422" data-mp="2y9hv7r0c1hez">
                <span className="block font-display text-xl font-bold uppercase tracking-wide text-steel-400" data-id="element-1423" data-mp="329ib7g32y0o5">
                  Built piece by piece
                </span>
                <span className="mt-0.5 block text-[13px] text-steel-500" data-id="element-1424" data-mp="2t8anfry6wi8b">X1 Essential + Full Lens System + hard case</span>
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-steel-400" data-id="element-1425" data-mp="3gyxz8ob87s05">
                {valueTotals.builtSeparately}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 bg-ink-850 px-5 py-4 sm:px-6" data-id="element-1426" data-mp="378lccpfxvmqu">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1427" data-mp="3c5vbwxx1lese">
                As a Complete System
              </span>
              <span className="text-right" data-id="element-1428" data-mp="8htey9ng98rz">
                <span className="block font-display text-3xl font-extrabold leading-none text-grit-500" data-id="element-1429" data-mp="8jnz3lqwcwv0">
                  {valueTotals.payOne}
                </span>
                <span className="mt-1 block text-[11px] font-bold uppercase tracking-[0.18em] text-grit-500" data-id="element-1430" data-mp="2bzjeufi445y7">
                  {valueTotals.saveVsBuilt} less, plus pouch and cloth
                </span>
              </span>
            </div>

            <a href="#offer" onClick={event => {
            event.preventDefault();
            requestOffer('single');
          }} className="group block bg-grit-500 px-5 py-6 text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-offwhite sm:px-6" data-id="element-1431" data-mp="223pwuglmjk91">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em]" data-id="element-1432" data-mp="3ifv9i6lq75p1">Complete System price</p>
              <p className="mt-2 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-1433" data-mp="3dowowutpflfz">
                <span className="font-display text-5xl font-extrabold leading-none sm:text-6xl" data-id="element-1434" data-mp="3dnlnv2rn8rsk">
                  {valueTotals.payOne}
                </span>
                <span className="pb-1.5 font-display text-lg font-bold uppercase sm:text-xl" data-id="element-1435" data-mp="3q0fng1vi4g69">
                  for the complete system
                </span>
              </p>
              <p className="mt-3 font-display text-xl font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-1436" data-mp="3spokapb0960">
                Or {valueTotals.payEach} per X1 with Buy 2, Get 1 Free.
              </p>
              <p className="mt-4 inline-flex items-center gap-2 font-display text-xl font-extrabold uppercase tracking-wide" data-id="element-1437" data-mp="cscfu3objylc">
                Choose your pack
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-1438" data-mp="hm6z5600ibjw" />
              </p>
            </a>
          </div>

          <div data-id="element-1439" data-mp="viu4nx616a1f">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1440" data-mp="vkf3hyzdof53">In every box</p>
            <ul className="mt-4 max-w-md" data-id="element-1441" data-mp="2skrl0rrm6pqu">
              {valueStack.map(item => <li key={item} className="flex items-center gap-3 border-b border-white/10 py-3.5 text-base font-medium text-offwhite sm:text-lg" data-id="element-1442" data-mp="2nmgbki58eh95">
                  <CheckIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-1443" data-mp="2wl1u4dapdw9x" />
                  {item}
                </li>)}
            </ul>

            <figure className="mt-8 border border-white/10 bg-ink-900" data-id="element-1444" data-mp="36c69he4ajj5a">
              <div className="relative" data-id="element-1445" data-mp="3kbfls2pdlt3z">
                <img src={media.detailSheet} alt="The GritVue X1 frame with its light module, clear, amber and smoke lenses and USB-C charging" className="block h-auto w-full" data-id="element-1446" data-mp="3kaebw1k3jcnu" />
                <GuaranteeBadge compact box={{
                left: '17.2%',
                top: '37.4%',
                width: '17.4%',
                height: '9.2%'
              }} data-id="element-1447" data-mp="1pz7vx3rww2f2" />
                <ShopHotspot box={{
                left: '3.3%',
                top: '38.4%',
                width: '14.2%',
                height: '7%'
              }} data-id="element-1448" data-mp="1bt60uiefduxw" />
              </div>
              <figcaption className="border-t border-white/10 px-4 py-3 text-[13px] text-steel-400" data-id="element-1449" data-mp="1fsogozre3ftv">
                The X1 Complete System: illuminated frame, all three lenses and USB-C charging.
              </figcaption>
            </figure>

            <ul className="mt-6 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-3" data-id="element-1450" data-mp="s3dr8efhp7v1">
              {offers.map(offer => <li key={offer.id} data-id="element-1451" data-mp="x3rnz0bn4vdr">
                  <a href="#offer" onClick={event => {
                event.preventDefault();
                requestOffer(offer.id);
              }} aria-label={`${offer.units} for ${offer.price}. Go to this pack`} className={`block h-full px-4 py-4 transition-[background-color,transform] duration-150 ease-grit active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'bg-ink-900 hover:bg-ink-800'}`} data-id="element-1452" data-mp="x0vrzhjcsgry">
                    <p className={`font-display text-xl font-extrabold uppercase leading-none ${offer.featured ? 'text-ink-950' : 'text-offwhite'}`} data-id="element-1453" data-mp="3h9e1hjin9fda">
                      {offer.kicker}
                    </p>
                    <p className={`mt-1 font-display text-3xl font-extrabold leading-none ${offer.featured ? 'text-ink-950' : 'text-grit-500'}`} data-id="element-1454" data-mp="339l455cm40wc">
                      {offer.price}
                    </p>
                    <p className={`mt-1 text-[11px] font-bold uppercase tracking-wide ${offer.featured ? 'text-ink-950/70' : 'text-steel-400'}`} data-id="element-1455" data-mp="wk6hpzsva1qx">
                      {offer.perUnit ?? offer.discountBadge ?? 'Single system'}
                    </p>
                  </a>
                </li>)}
            </ul>

            <p className="grit-headline mt-8 text-[clamp(1.75rem,6vw,3rem)] font-extrabold uppercase text-offwhite" data-id="element-1456" data-mp="2k7cgrtznkgfp">
              See further.
              <br data-id="element-1457" data-mp="1rif01vb3arp2" />
              <span className="text-grit-500" data-id="element-1458" data-mp="1rix5nijn6i9n">Work smarter.</span>
            </p>
            <p className="mt-3 text-[15px] font-semibold uppercase tracking-wide text-steel-300" data-id="element-1459" data-mp="1wggkajk94x24">
              Built for the people who keep America moving.
            </p>
            <p className="mt-1 text-[13px] text-steel-500" data-id="element-1460" data-mp="25hn34zadijyj">Prescription ready.</p>

            <CtaButton offer="trio" className="mt-6 w-full sm:w-auto" data-id="element-1461" data-mp="25fk4jqv5nii7">
              Get 3 X1 Systems for $99.90
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}